import z from "zod";

const kkiapayWebhook = z.object({
  transactionId: z.string(),
  isPaymentSucces: z.boolean(),
  account: z.string().nullable(),
  failureCode: z.string().optional(),
  failureMessage: z.string().optional(),
  label: z.string(),
  method: z.string(),
  amount: z.number().positive(),
  fees: z.number().positive(),
  partnerId: z.string(),
  performedAt: z.string().datetime(),
  stateData: z.record(z.any()),
  event: z.string().regex(/^(transaction\.failed|transaction\.succeeded)$/),
});

export type KkiapayWebhook = z.infer<typeof kkiapayWebhook>;
